export const fipayTagData = [
  {
    item1: "Allowed characters are a-z, 0-9, and underscores (_)",
    item2: "Minimum character length is 4 characters",
  },
];
